module.exports = __webpack_public_path__ + "static/img/PublicApkDownLoadPic.9b19306.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/PublicApkDownLoadPic.png
// module id = 2xTt
// module chunks = 1